import { useCallback, useState } from 'react'

import { ConversationBootstrapModes } from '../../hooks/useConversationStream'
import { useStartGuidedIntake } from '../../hooks/useStartGuidedIntake'
import { useGlobalSearch } from '../../providers/GlobalSearchProvider'
import { GuidedIntakeEntryPoints } from '../../value-objects/enums'

export const useGlobalCommandView = () => {
  const { conversationBootstrap, openConversation, endConversation } =
    useGlobalSearch()
  const startGuidedIntake = useStartGuidedIntake()
  const [isGuidedIntakePromoOpen, setIsGuidedIntakePromoOpen] = useState(false)

  const startConversation = useCallback(
    (query: string) => {
      openConversation({
        mode: ConversationBootstrapModes.NEW,
        initialQuery: query,
      })
    },
    [openConversation]
  )

  const resumeConversation = useCallback(
    (conversationId: string) => {
      openConversation({
        mode: ConversationBootstrapModes.RESUME,
        conversationId,
      })
    },
    [openConversation]
  )

  const startGuidedIntakeFromSearch = useCallback(() => {
    startGuidedIntake({
      entryPoint: GuidedIntakeEntryPoints.SEARCH_OVERLAY,
      primaryCategoryId: null,
      secondaryCategoryId: null,
    })
  }, [startGuidedIntake])

  const openGuidedIntakePromo = useCallback(() => {
    setIsGuidedIntakePromoOpen(true)
  }, [])

  const closeGuidedIntakePromo = useCallback(() => {
    setIsGuidedIntakePromoOpen(false)
  }, [])

  return {
    data: { bootstrap: conversationBootstrap },
    states: { isGuidedIntakePromoOpen },
    methods: {
      startConversation,
      resumeConversation,
      startGuidedIntakeFromSearch,
      endConversation,
      openGuidedIntakePromo,
      closeGuidedIntakePromo,
    },
  }
}
